import {Component, forwardRef, Host, OnInit, Optional, SkipSelf} from '@angular/core';

import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';

import {PanelInputComponent} from '../../components';
import {InputComponentTypesEnum} from '../../enums';
import {PasswordControl} from '../../classes';

@Component({
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PasswordInputComponent),
        multi: true
    }]
})
export class PasswordInputComponent extends PanelInputComponent implements OnInit {
    public passwordInputType: string;
    public inputComponentTypes: typeof InputComponentTypesEnum;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);

        this.passwordInputType = InputComponentTypesEnum.Password;
        this.inputComponentTypes = InputComponentTypesEnum;
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    changePasswordInputType(event: MouseEvent): void {
        this.passwordInputType =
            (this.passwordInputType !== InputComponentTypesEnum.Password) ? InputComponentTypesEnum.Password : InputComponentTypesEnum.Text;

        event.stopPropagation();
    }

    asFormsControl(): PasswordControl {
        if (!this.control) {
            this.control = new PasswordControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: 0,
                invalid: false,
                hintDisabled: false,
                errors: []
            });
        }

        return (this.control as PasswordControl);
    }
}
